var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40156 1.19998C7.40156 1.04085 7.33835 0.888233 7.22583 0.775711C7.11331 0.66319 6.96069 0.599976 6.80156 0.599976C6.64243 0.599976 6.48982 0.66319 6.3773 0.775711C6.26478 0.888233 6.20156 1.04085 6.20156 1.19998V6.19998H1.20156C1.04243 6.19998 0.88982 6.26319 0.777298 6.37571C0.664777 6.48823 0.601562 6.64085 0.601562 6.79998C0.601562 6.95911 0.664777 7.11172 0.777298 7.22424C0.88982 7.33676 1.04243 7.39998 1.20156 7.39998H6.20156V12.4C6.20156 12.5591 6.26478 12.7117 6.3773 12.8242C6.48982 12.9368 6.64243 13 6.80156 13C6.96069 13 7.11331 12.9368 7.22583 12.8242C7.33835 12.7117 7.40156 12.5591 7.40156 12.4V7.39998H12.4016C12.5607 7.39998 12.7133 7.33676 12.8258 7.22424C12.9383 7.11172 13.0016 6.95911 13.0016 6.79998C13.0016 6.64085 12.9383 6.48823 12.8258 6.37571C12.7133 6.26319 12.5607 6.19998 12.4016 6.19998H7.40156V1.19998Z",
    fill: "#F0B429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.de2989145b3ddf2776afe716b6196111.svg";
export { ForwardRef as ReactComponent };